import React, { useState, useEffect } from 'react'

import Section from '../../../react4xp/components/Section'
import Input from '../../../react4xp/components/Form/Input'
import Button from '../../../react4xp/components/Button'
import { GeneralSearch } from '../../../react4xp/components/Svg/Icons/General'

function SearchResultsPart({ heading, pagination, strings, startValues }) {
    const [results, setResults] = useState<any[]>([])
    const [page, setPage] = useState(pagination.page || 1)
    const [hasNextPage, setHasNextPage] = useState(false)
    const [loadMore, setLoadMore] = useState(false)
    const [total, setTotal] = useState(0)

    const [inputValue, setInputValue] = useState(startValues.search || '')
    const [searchTerm, setSearchTerm] = useState(startValues.search || '')
    const [isResultsVisible, setIsResultsVisible] = useState(false)

    useEffect(() => {
        if (searchTerm) {
            handleFetchResults()
        }
    }, [searchTerm, page])

    const handleFetchResults = async () => {
        if (!pagination.endpoint) return;

        const origin = window.location.origin;
        const url = new URL(pagination.endpoint);
        const queryParams = new URLSearchParams();

        if (page) queryParams.append('page', String(page));
        if (pagination.pageSize) queryParams.append('pageSize', pagination.pageSize);
        if (searchTerm) queryParams.append('search', searchTerm);

        url.search = queryParams.toString();

        updateCurrentUrl()

        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }
            const data = await response.json();

            if (loadMore) {
                setResults([...results, ...data.hits]);
                setLoadMore(false)
            } else {
                setResults(data.hits);
            }

            setHasNextPage(data.hasNextPage);
            setTotal(data.total)

        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
        }
        setIsResultsVisible(true)
    }

    const updateCurrentUrl = () => {
        const origin = window.location.origin;
        const updatedUrl = new URL(`${origin}${window.location.pathname}`);
        const queryParams = new URLSearchParams();

        if (searchTerm) queryParams.append('search', searchTerm);

        updatedUrl.search = queryParams.toString();
        window.history.pushState({}, '', updatedUrl);
    }

    const handleLoadMore = () => {
        if (hasNextPage) {
            setLoadMore(true)
            setPage(page + 1)
        }
    }
    
    const handleSearchTerm = () => {
        setPage(1)
        setSearchTerm(inputValue)

        setTimeout(() => {
			const searchResultsElement = document.getElementById('search-results')
			if (searchResultsElement) {
				const headerOffset = 0
				const elementPosition = searchResultsElement.getBoundingClientRect().top + window.scrollY
				const offsetPosition = elementPosition - headerOffset
	
				window.scrollTo({
					top: offsetPosition,
					behavior: 'smooth'
				})
			}
		}, 100)
	}

    // highlight search term
	const highlightText = (text) => {
		if (!searchTerm.trim()) {
			return text
		}
		const regex = new RegExp(`(${searchTerm})`, 'gi')
		return text.split(regex).map((part, i) => 
			regex.test(part) ? <span key={i} className='highlight'>{part}</span> : part
		)
	}

    return (
        <Section bgColor='red' paddingTop='small'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-10 offset-lg-1 col-xl-8 offset-xl-2'>

                        <div className='page-search__search-box'>
                            <div className='box bg-white'>

                                <h1 className='h2'>
                                    {heading}
                                </h1>

                                <div className='search-form'>

                                    <Input
                                        id='search'
                                        size='large'
                                        name='Hva leter du etter?'
                                        label='Hva leter du etter?'
                                        type='text'
                                        required
                                        errorMessages={{
                                            required: 'Dette feltet er obligatorisk'
                                        }}
                                        value={inputValue}
                                        onChange={(e) => setInputValue(e.target.value)}
                                        onKeyDown={handleSearchTerm}
                                    />

                                    <Button
                                        color='black'
                                        hover='red'
                                        noUnderline
                                        smallBorders
                                        onClick={() => handleSearchTerm()}
                                    >
                                        {strings.searchButton} <GeneralSearch variant='outline' />

                                    </Button>

                                </div>

                            </div>
                        </div>

                        {isResultsVisible && (
                            <div className='page-search__search-results' id='search-results'>
                                <div className='box bg-white'>

                                    <h2 className='h2'>
                                        {strings.resultsHeading}
                                    </h2>

                                    <p>{total} {strings.resultsForCount} "{searchTerm}"</p>

                                    {results.length > 0 ? (
                                        <div className='list'>

                                            {results.map((item, i) => (
                                                <a href={item.url} className='item' key={i}>

                                                    <p className='h4'>
                                                        {highlightText(item.title)}
                                                    </p>

                                                    <p>
                                                        {highlightText(item.description)}
                                                    </p>

                                                </a>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className='no-results'>
                                            <p className='h4'>
                                                {strings.noResults1} {strings.noResults2}
                                            </p>
                                        </div>
                                    )}

                                    {hasNextPage && (
                                        <Button
                                            className='load-more'
                                            hasBorders
                                            noUnderline
                                            hover='blue'
                                            onClick={handleLoadMore}
                                        >
                                            {strings.loadMore}
                                        </Button>
                                    )}

                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </Section>
    )
}

export default (props) => <SearchResultsPart {...props} />
